export default {
  nav: {
    home: 'Home',
    products: 'Products',
    solutions: 'Solutions',
    ecosystem: 'Ecosystem',
    about: 'About',
    start: 'Get Started'
  },
  sections: {
    hero: {
      title: 'Building a Decentralized Future',
      subtitle: 'KOMA is dedicated to building next-generation blockchain infrastructure, providing high-performance, secure and reliable operating environment for decentralized applications',
      whitepaper: 'View Whitepaper',
      join: 'Join Community',
      features: {
        performance: {
          title: 'High Performance',
          description: 'Supporting tens of thousands of transactions per second, meeting enterprise-level application requirements'
        },
        community: {
          title: 'Community Driven',
          description: 'Governed by the global community, achieving true decentralization'
        },
        innovation: {
          title: 'Innovative Technology',
          description: 'Using cutting-edge blockchain technology to build secure and reliable infrastructure'
        },
        national: {
          title: 'Asta International',
          description: 'International Legal Department of Daye Zongheng Foundation [International Legal Execution Agency]'
        },
        huge: {
          title: 'Daye Zongheng',
          description: 'International Business Department of Daye Zongheng Foundation [International Business Execution Agency]'
        },
        dragon: {
          title: 'Dragon & Phoenix',
          description: 'Perfect fusion of innovation and tradition, pioneering a new era of blockchain'
        }
      }
    },
    vision: {
      title: 'Why Choose KOMA',
      subtitle: 'We provide comprehensive blockchain solutions, from technical architecture to application scenarios, offering the best choice for your digital asset management',
      features: {
        security: {
          title: 'Secure & Reliable',
          description: 'Using multi-signature and smart contract auditing to ensure asset security. Stable system operation with 24/7 technical support.'
        },
        strategy: {
          title: 'Smart Strategy',
          description: 'Machine learning-based intelligent trading strategies, automatically identifying market opportunities and optimizing investment portfolios.'
        },
        performance: {
          title: 'High Performance',
          description: 'Supporting tens of thousands of transactions per second, millisecond-level latency, meeting professional trading needs.'
        }
      }
    },
    token: {
      title: 'Ecosystem',
      subtitle: 'The KOMA ecosystem covers multiple fields including DeFi, NFT, DAO, providing comprehensive blockchain services for users',
      learnMore: 'Learn More',
      features: {
        defi: {
          title: 'DeFi Finance',
          description: 'Decentralized lending, liquidity mining, yield aggregator'
        },
        nft: {
          title: 'NFT Marketplace',
          description: 'Digital art trading, gaming assets, virtual items'
        },
        dao: {
          title: 'DAO Governance',
          description: 'Community governance, proposal voting, incentive mechanisms'
        },
        gamefi: {
          title: 'GameFi',
          description: 'Blockchain gaming, game asset trading, Play to Earn'
        }
      }
    },
    economy: {
      title: 'Token Economy',
      subtitle: 'KOMA token is the core of the ecosystem, used for governance, staking and transaction fees',
      details: {
        title: 'Token Distribution Details',
        ecosystem: 'Ecosystem Fund',
        team: 'Team Holdings',
        private: 'Private Sale',
        public: 'Public Sale',
        community: 'Community Incentives'
      }
    },
    resonance: {
      title: 'Development Roadmap',
      subtitle: 'KOMA\'s development plan and key milestones',
      q4: {
        item1: 'Complete core technical architecture development',
        item2: 'Launch test network',
        item3: 'Complete security audit'
      },
      q1: {
        item1: 'Mainnet launch',
        item2: 'Token issuance',
        item3: 'DeFi ecosystem construction'
      },
      q2: {
        item1: 'NFT marketplace launch',
        item2: 'GameFi platform launch',
        item3: 'Cross-chain bridge deployment'
      },
      q3q4: {
        item1: 'Layer2 scaling solution',
        item2: 'DAO governance system upgrade',
        item3: 'Global ecosystem expansion'
      }
    },
    tech: {
      team: {
        title: 'Technical Team',
        subtitle: 'Core team composed of senior blockchain industry experts',
        membersOne: {
          name: 'John Smith',
          title: 'Technical Director',
          description: 'Former technical lead at a well-known blockchain company, with rich blockchain development experience'
        },
        membersTwo: {
          name: 'Sarah Johnson',
          title: 'Architect',
          description: 'Focused on blockchain underlying technology research, participated in multiple public chain project development'
        },
        membersThree: {
          name: 'Michael Brown',
          title: 'Security Expert',
          description: 'Blockchain security expert, responsible for security audits of multiple large-scale projects'
        },
        membersFour: {
          name: 'Emily Davis',
          title: 'Product Manager',
          description: 'Rich blockchain product experience, focused on user experience optimization'
        }
      },
      partners: {
        title: 'Partners',
        subtitle: 'Strategic partnerships with industry leaders'
      },
      cta: {
        title: 'Join Us',
        subtitle: 'Let\'s build the future of blockchain together',
        startButton: 'Get Started',
        docsButton: 'View Docs'
      }
    },
    footer: {
      slogan: 'Building a Decentralized Future',
      product: {
        title: 'Product',
        architecture: 'Architecture',
        docs: 'Documentation',
        api: 'API'
      },
      resources: {
        title: 'Resources',
        blog: 'Blog',
        community: 'Community',
        help: 'Help Center'
      },
      contact: {
        title: 'Contact',
        twitter: 'Twitter',
        discord: 'Discord',
        telegram: 'Telegram'
      },
      copyright: '© 2024 KOMA. All rights reserved.'
    }
  }
} 